import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { withRouter } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Search from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import CameraRear from "@material-ui/icons/CameraRear";
import Dialog from "@material-ui/core/Dialog";
import Close from "@material-ui/icons/Close";
import { get } from "lodash";

import { setBreadcrumb } from "../../actions/common";
import images from "../../assets/img/images";
import { fetchGet, fetchPost } from "../../api/fetch";
import VMITopBar from "./VMITopBar";
import DropdownDown from "./assets/dropdown_arrow_down.svg";
import MultiLevel from "./assets/Multi-level icon.svg";
import Barcode from "./assets/mdi_barcode_scan.svg";
import MobileCreateOrderRequest from "./MobileCreateOrderRequest";
import ScanPopup from "./ScanPopup";
import QrPopup from "./QrPopup";
import MobileVmiZones from "./MobileVmiZones";
import colors from "../../assets/style/colors";
import { ListItemText, MenuItem, Radio, Select } from "@material-ui/core";
import Orders from "./Orders";
import MultiSelect from "./MultiSelect";
import { fetchDataStoreKey } from "../../utils/datastore";

const styles = {
  mainContent: {
    minHeight: 0,
    margin: "24px 0 0 24px",
    padding: "24px",
    width: "calc(100vw - 128px)",
    height: "calc(100vh - 140px)",
    "@media(max-width: 470px)": {
      margin: "0",
      padding: "8px",
      borderRadius: "0",
      width: "100%",
      height: "100%",
      overflow: "hidden",
    },
  },
  container: {
    height: "40px",
    width: "100%",
    backgroundColor: colors.white,
    paddingLeft: "24px",
    boxShadow: `0px 0px 4px 0px ${colors.black23}`,
  },
  input: {
    backgroundColor: "white",
    width: "349px",
  },
  controlSection: {
    marginBottom: "16px",
    display: "flex",
    alignItems: "center",
  },
  scanProduct: {
    display: "inline-flex",
    alignItems: "center",
    cursor: "pointer",
    width: "48px",
    padding: "12px 0px 12px 0px",
    margin: "0px 12px 0px 12px",
    "@media(max-width: 470px)": {
      height: "48px",
      padding: "0px 0px 0px 4px",
      margin: "0px 0px 0px 0px",
    },
  },
  dropdownSection: {
    display: "inline-block",
    "@media(max-width: 470px)": {
      paddingTop: "5px",
    },
  },
  dropdownSelect: {
    margin: "0px 32px",
    minWidth: "280px",
    border: "1px solid rgba(0,0,0,0.23)",
    borderRadius: "2px",
    paddingLeft: "8px",
    "&::before": {
      borderBottom: "none",
    },
    "@media(max-width: 470px)": {
      margin: "0px",
      display: "inline-block",
      minWidth: "190px",
    },
  },
  dropdownSite: {
    paddingLeft: "30px",
  },
  dropdownSector: {
    paddingLeft: "60px",
  },
  dropdownVmi: {
    paddingLeft: "90px",
  },
  confirmBtn: {
    width: "112px",
    height: "36px",
    backgroundColor: "#0097A7",
    borderRadius: "2px",
    border: "none",
    color: "white",
    fontWeight: "500",
    boxShadow: "0px 2px 2px #00000033",
  },
  disabledButton: {
    backgroundColor: "#dddddd",
    color: "#00000061",
    userSelect: "none",
    pointerEvents: "none",
  },
  requestButton: {
    cursor: "not-allowed",
    pointerEvents: "none",
  },
  displayView: {
    paddingTop: "30px",
    "@media(max-width: 470px)": {
      paddingTop: "0",
    },
  },
  selectionSection: {
    display: "flex",
  },
  selectionOption: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    marginRight: "16px",
  },
  // VMI List Wrapper
  vmiTableContainer: {
    height: "605px",
    overflow: "auto",
    "& table": {
      borderCollapse: "separate",
      tableLayout: "fixed",
    },
    "& table thead": {
      "@media(max-width: 470px) ": {
        display: "none",
      },
    },
    "& table thead tr": {
      backgroundColor: "white",
      height: "70px",
    },
    "& table thead tr th": {
      backgroundColor: "#e5f4f6",
      position: "sticky",
      top: "0px",
      zIndex: "1",
    },
    "& table thead tr th:not(:last-child)": {
      borderRight: "3px solid white",
      backgroundClip: "padding-box",
      boxSizing: "border-box",
    },
    "& table tbody tr td": {
      height: "50px",
      color: "rgba(0, 0, 0, 0.54)",
      paddingLeft: "12px",
      cursor: "pointer",
    },
    "& table tbody tr": {
      "@media(max-width: 470px)": {
        display: "grid",
        gridTemplateColumns: "1fr 20px",
        gridTemplateRows: "18px 18px",
        rowGap: "2px",
        width: "100%",
        padding: "8px 0",
        "& td": {
          height: "16px",
          padding: "0",
          boxSizing: "border-box",
          display: "flex",
        },
      },
    },
    "@media(max-width: 470px)": {
      width: "100%",
    },
  },
  containerReq: {
    width: "calc(210px + 195px + 185px + 270px + 90px + 12px)",
    height: "605px",
  },
  containerOrd: {
    width: "100%",
    height: "650px",
  },
  tableAdmin: {
    width: "calc(210px 195px 185px 270px 90px)",
    "@media(max-width: 470px)": {
      width: "100%",
    },
  },
  // VMI TABLE
  evenRow: {
    backgroundColor: "#f8f8f8",
  },
  tableRow: {
    borderBottom: "1px solid #dddddd",
    display: "grid",
    gridTemplateColumns: "210px 195px 185px 270px 90px",
    gridColumnGap: "3px",
    "&:hover": {
      backgroundColor: "#f2f9fa",
      cursor: "pointer",
    },
    "& th": {
      height: "50px",
    },
    "& td": {
      color: "rgba(0,0,0,0.54)",
      height: "50px",
      padding: "0px 12px",
      boxSizing: "border-box",
      display: "flex",
      alignItems: "center",
    },
    "@media(max-width: 470px)": {
      display: "grid",
      gridTemplateColumns: "1fr 20px",
      gridTemplateRows: "18px 18px",
      rowGap: "2px",
      width: "100%",
      padding: "8px 0",
      "& td": {
        height: "16px",
        padding: "0",
        boxSizing: "border-box",
        display: "flex",
      },
    },
  },
  cellContent: {
    fontWeight: "500",
    color: "rgba(0,0,0,0.87)",
  },
  goTo: {
    gridArea: "1 / 2 / 3 / 3",
    alignSelf: "center",
  },

  tableCheckbox: {
    width: "70px",
    marginRight: "3px",
  },
  tableCode: {
    position: "sticky",
    top: 0,
  },
  vmiSort: {
    display: "flex",
  },
  tableSubtitle: {
    fontWeight: "500",
    padding: "0 12px",
    textAlign: "left",
    boxSizing: "border-box",
  },
  blueText: {
    color: "#0097a7",
    fontWeight: "500",
    cursor: "pointer",
  },
  sortContainer: {
    marginRight: "4px",
    cursor: "pointer",
  },
  dropdownInverted: {
    transform: "rotate(180deg)",
  },
  rowLastOrder: {
    boxSizing: "border-box",
    padding: "0 12px",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
  selections: {
    marginLeft: "32px",
  },
  delete: {
    color: "#eb3c39",
    marginLeft: "8px",
  },
  statusBar: {
    width: "985px",
    height: "24px",
    marginBottom: "6px",
    display: "flex",
    justifyContent: "space-between",
    fontSize: "14px",
  },
  productSelection: {
    display: "flex",
  },
  statusBarActions: {
    display: "flex",
  },
  deselectLastOrder: {
    color: "#0097a7",
    marginRight: "28px",
    cursor: "pointer",
  },
  actionButtons: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gridColumnGap: "16px",
  },
  orderRequestNav: {
    width: "985px",
    display: "flex",
    justifyContent: "space-between",
  },
  ctaContainer: {
    display: "flex",
    alignItems: "center",
  },
  qtyCell: {
    width: "100%",
    textAlign: "center",
  },
  expandVmi: {
    marginBottom: "12px",
    cursor: "pointer",
  },
  emptyVMI: {
    marginTop: "32px",
  },
  dialogPaper: {
    width: "100%",
    maxHeight: "100%",
    maxWidth: "360px",
    margin: 0,
  },
  // Filter Dialog
  filterDialog: {
    width: "100%",
    maxWidth: "360px",
    height: "640px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    border: "1px solid #dddddd",
    padding: "16px 8px 12px",
    "@media(max-width: 470px)": {
      height: "640px",
    },
  },
  scanProductNav: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    marginBottom: "8px",
  },
  closeButtonContainer: {
    marginRight: "4px",
  },
  filterContainer: {
    height: "100%",
    width: "100%",
  },
  // Table Header Search Fields
  inputContainer: {
    padding: "0 12px",
    width: "100%",
    boxSizing: "border-box",
  },
  searchCodeInput: {
    backgroundColor: "white",
    width: "100%",
    height: "36px",
    paddingLeft: "7px",
  },
};

const VMITable = (props) => {
  const { history, classes, dispatch } = props;

  const [sendingRequest, setSendingRequest] = React.useState(false);
  const [allVmi, setAllVmi] = React.useState([]);
  const [populatedVmi, setPopulatedVmi] = React.useState([]);
  const [emptyVmi, setEmptyVmi] = React.useState([]);
  // Sort State
  const [sortByVmiName, setSortByVmiName] = React.useState(false);
  // Selection State
  const [selectAll, setSelectAll] = React.useState(true);
  const [selectPop, setSelectPop] = React.useState(false);
  const [selectEmp, setSelectEmp] = React.useState(false);
  const [selection, setSelection] = React.useState("tous");
  // Scan Dialog State Logic
  const [scanDialog, setOpenScan] = React.useState(false);
  const [selectedProductData, setSelectedProductData] = React.useState({});
  const [editProductDialog, setOpenRequest] = React.useState(false);
  const [selectedZoneId, setSelectedZoneId] = React.useState({});
  const [zoneDialog, setOpenZone] = React.useState(false);
  // Qr Scanning using back camera
  const [hasQrScan, setHasQrScan] = React.useState(false);
  const [qrDialogOpen, setQrDialogOpen] = React.useState(false);
  // Filter Dialog
  const [filterDialog, setOpenFilter] = React.useState(false);
  // Scan Error
  const [scanError, setScanError] = React.useState("");
  // Tab View
  const [componentTab, setComponentTab] = React.useState(
    get(props, ["match", "params", "tab"])
  );
  // MultiSelect Dropdown
  const [multiSelectZones, setMultiSelectZones] = React.useState([]);

  function getWidth() {
    return Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );
  }

  React.useEffect(() => {
    setComponentTab(props.match.params.tab);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.params.tab]);

  React.useEffect(() => {
    // VMI LIST
    try {
      fetchGet(`vmi`)
        .then((data) => {
          setAllVmi(data);
          setPopulatedVmi(data.filter((v) => v.product_count >= 1));
          setEmptyVmi(
            data
              .filter((v) => v.product_count === 0)
              .sort((a, b) =>
                a.vmi_name.localeCompare(b.vmi_name, "en", {
                  sensitivity: "base",
                })
              )
          );
        })
        .catch((e) => console.error(e));
    } catch (e) {
      console.log(e);
    }
    let fetchQrFlag = async () => {
      let hasQrFlag = await fetchDataStoreKey("vmi.scan.has-qr");
      setHasQrScan(hasQrFlag == true);
      console.log(`VMITable - useEffect[]: hasQrScan: ${hasQrFlag == true}`);
    };
    fetchQrFlag();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    // BREADCRUMBS
    dispatch(
      setBreadcrumb([
        {
          name: I18n.get("sidebar_orders"),
        },
      ])
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    // SORT BY VMI NAME
    sortByVmiName
      ? setPopulatedVmi(
        populatedVmi.sort((a, b) =>
          a.vmi_name.localeCompare(b.vmi_name, "en", { sensitivity: "base" })
        )
      )
      : setPopulatedVmi(
        populatedVmi.sort((a, b) =>
          b.vmi_name.localeCompare(a.vmi_name, "en", { sensitivity: "base" })
        )
      );
    sortByVmiName
      ? setAllVmi(
        allVmi.sort((a, b) =>
          a.vmi_name.localeCompare(b.vmi_name, "en", { sensitivity: "base" })
        )
      )
      : setAllVmi(
        allVmi.sort((a, b) =>
          b.vmi_name.localeCompare(a.vmi_name, "en", { sensitivity: "base" })
        )
      );
    sortByVmiName
      ? setEmptyVmi(
        emptyVmi.sort((a, b) =>
          a.vmi_name.localeCompare(b.vmi_name, "en", { sensitivity: "base" })
        )
      )
      : setEmptyVmi(
        emptyVmi.sort((a, b) =>
          b.vmi_name.localeCompare(a.vmi_name, "en", { sensitivity: "base" })
        )
      );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortByVmiName]);

  const handleMultiSelect = (vmiIds) => {
    setMultiSelectZones(vmiIds);
    setOpenFilter(false);
  };

  React.useEffect(() => {
    try {
      fetchGet(
        multiSelectZones.length > 0
          ? `vmi?ids=${multiSelectZones.join(",")}`
          : `vmi`
      )
        .then((data) => {
          setAllVmi(data);
          setPopulatedVmi(data.filter((v) => v.product_count >= 1));
          setEmptyVmi(
            data
              .filter((v) => v.product_count === 0)
              .sort((a, b) =>
                a.vmi_name.localeCompare(b.vmi_name, "en", {
                  sensitivity: "base",
                })
              )
          );
        })
        .catch((e) => console.error(e));
    } catch (e) {
      console.log(e);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [multiSelectZones]);

  const handleScanDialog = (scanId) => {
    if (scanId > 100000) {
      // Scan PZI ID - Order Request Dialog
      const body = {
        description: null,
        code_product: null,
        vendor_name: null,
        ogc: null,
        category: null,
        limit: 10,
        vmi: null,
        codebin: scanId,
        pzitbl: true,
      };

      try {
        fetchPost("products/search", body)
          .then((product) => {
            if (product[0]) {
              if (product[0].order_request_id) {
                fetchGet(`order_request/${product[0].order_request_id}`).then(
                  (orderRequest) => {
                    console.log(orderRequest);
                    orderRequest["order_request_id"] = orderRequest["id"];
                    orderRequest["order_request_quantity"] =
                      orderRequest["quantity"];
                    orderRequest["order_request_units"] =
                      orderRequest["unit_of_measurement"];
                    setOpenScan(false);
                    setQrDialogOpen(false);
                    setSelectedProductData({
                      id: product[0].product_id,
                      orderRequest,
                      zoneId: product[0].zone_id,
                      pziId: scanId,
                    });
                    setOpenRequest(true);
                  }
                );
              } else {
                setOpenScan(false);
                setQrDialogOpen(false);
                setSelectedProductData({
                  id: product[0].product_id,
                  orderRequest: null,
                  zoneId: product[0].zone_id,
                  pziId: scanId,
                });
                setOpenRequest(true);
              }
            } else {
              setScanError(
                I18n.get("profiles_noResultsFound") + " (" + scanId + ")"
              );
            }
          })
          .catch((e) => {
            console.error(e);
          });
      } catch (e) {
        console.log(e);
      }
    } else {
      //Scan Zone ID - Zone Navigation Dialog
      setSelectedZoneId(scanId);
      setOpenScan(false);
      setQrDialogOpen(false);
      setOpenZone(true);
    }
  };

  const handleBreadcrumbNavigation = (zoneId) => {
    setSelectedZoneId(zoneId);
    setOpenRequest(false);
    setOpenZone(true);
  };

  // TABLE DISPLAY SELECTION LOGIC
  const handleSelectAll = () => {
    if (!selectAll) {
      setSelectAll(true);
      setSelectEmp(false);
      setSelectPop(false);
    }
  };
  const handleSelectPop = () => {
    if (!selectPop) {
      setSelectPop(true);
      setSelectAll(false);
      setSelectEmp(false);
    }
  };
  const handleSelectEmp = () => {
    if (!selectEmp) {
      setSelectEmp(true);
      setSelectPop(false);
      setSelectAll(false);
    }
  };
  // Selection State Handler for Mobile View
  const handleSelection = (event) => {
    setSelection(event.target.value);
  };

  // RENDER VMI TABLE
  const renderVmiList = () => {
    let selectedOption;

    if (getWidth() > 478) {
      if (selectEmp) {
        selectedOption = emptyVmi;
      } else if (selectPop) {
        selectedOption = populatedVmi;
      } else {
        selectedOption = allVmi;
      }
    } else {
      if (selection === "sans") {
        selectedOption = emptyVmi;
      } else if (selection === "avec") {
        selectedOption = populatedVmi;
      } else {
        selectedOption = allVmi;
      }
    }

    return selectedOption
      .filter((v) =>
        !!Object.keys(filters).length
          ? v.vmi_name
            .toLowerCase()
            .includes(filters.VMI ? filters.VMI.toLowerCase() : "")
          : true
      )
      .filter((v) =>
        !!Object.keys(filters).length
          ? v.sector_name
            .toLowerCase()
            .includes(filters.sector ? filters.sector.toLowerCase() : "")
          : true
      )
      .filter((v) =>
        !!Object.keys(filters).length
          ? v.site_name
            .toLowerCase()
            .includes(filters.site ? filters.site.toLowerCase() : "")
          : true
      )
      .filter((v) =>
        !!Object.keys(filters).length
          ? v.company_name
            .toLowerCase()
            .includes(filters.company ? filters.company.toLowerCase() : "")
          : true
      )
      .map((v, i) =>
        getWidth() > 478 ? (
          <tr
            key={`vmi-${i}-${v.vmi_name}`}
            className={(i + 1) % 2 === 0 ? classes.evenRow : ""}
            onClick={() => history.push(`/wms/requests/${v.vmi_id}`)}
          >
            <td>{v.company_name}</td>
            <td>{v.site_name}</td>
            <td>{v.sector_name}</td>
            <td>
              <div>{v.vmi_name}</div>
            </td>
            <td>{v.product_count}</td>
          </tr>
        ) : (
          <tr
            key={`vmi-${i}-${v.vmi_name}`}
            onClick={() => history.push(`/wms/requests/${v.vmi_id}`)}
          >
            <td>
              <div className={classes.cellContent}>
                {v.vmi_name} ({v.sector_name})
              </div>
            </td>
            <td>
              {v.product_count === 1
                ? `${v.product_count} product`
                : `${v.product_count} products`}
            </td>
            <td className={classes.goTo}>
              <img
                src={images.breadcrumbIcon}
                height="12px"
                alt=">"
                color={"black"}
                className={classes.breadcrumbIcon}
              />
            </td>
          </tr>
        )
      );
  };

  const handleChangeView = (view) => {
    if (view === "requests") {
      history.push(`/wms/requests_orders/requests`);
    } else {
      history.push(`/wms/requests_orders/orders`);
    }
  };

  const [filters, setFilters] = React.useState({});

  const addFilter = (e, idx) => {
    const newElements = { ...filters };
    newElements[idx] = e.target.value;
    setFilters(newElements);
  };

  const removeFilter = (key) => {
    const newElements = { ...filters };
    newElements[key] = "";
    setFilters(newElements);

    setFilters((current) => {
      // create copy of state object
      const copy = { ...current };

      // remove salary key from object
      delete copy[key];

      return copy;
    });
  };

  return (
    <>
      <Grid
        container
        direction="column"
        wrap="nowrap"
        className={`mainContent ${classes.mainContent}`}
      >
        <Grid item>
          <div className={classes.controlSection}>
            <div
              className={classes.scanProduct}
              onClick={() => setOpenScan(true)}
            >
              <img src={Barcode} alt="Scan Product" />
            </div>
            {hasQrScan && (
              <div
                className={classes.scanProduct}
                onClick={() => setQrDialogOpen(true)}
              >
                <CameraRear color="primary" />
              </div>
            )}
            {getWidth() < 478 ? (
              <div
                className={classes.scanProduct}
                onClick={() => setOpenFilter(true)}
              >
                <img src={MultiLevel} alt="Filter Zones" />
              </div>
            ) : null}

            <div className={classes.dropdownSection}>
              {getWidth() > 478 ? (
                <>
                </>
              ) : (
                <>
                  {componentTab === "requests" ? (
                    <Select
                      value={selection}
                      onChange={handleSelection}
                      MenuProps={{
                        getContentAnchorEl: null,
                        PaperProps: {
                          style: {
                            maxHeight: getWidth() > 478 ? 360 : 540,
                            width: getWidth() > 478 ? 250 : 190,
                          },
                        },
                      }}
                      className={classes.dropdownSelect}
                      disableUnderline={true}
                    >
                      <MenuItem key={`zone-select-all`} value={"tous"}>
                        <ListItemText primary={I18n.get("all_vmi")} />
                      </MenuItem>
                      <MenuItem key={`zone-select-with`} value={"avec"}>
                        <ListItemText primary={I18n.get("vmi_with")} />
                      </MenuItem>
                      <MenuItem key={`zone-select-wo`} value={"sans"}>
                        <ListItemText primary={I18n.get("vmi_without")} />
                      </MenuItem>
                    </Select>
                  ) : null}
                </>
              )}
            </div>
          </div>
          <Dialog
            open={editProductDialog}
            fullWidth
            classes={{ paper: classes.dialogPaper }}
            onBackdropClick={() => setOpenRequest(false)}
          >
            <MobileCreateOrderRequest
              setOpenScan={setOpenScan}
              setOpenRequest={setOpenRequest}
              setSelectedProductData={setSelectedProductData}
              productData={selectedProductData}
              handleBreadcrumbNavigation={handleBreadcrumbNavigation}
              noReScan={true}
            />
          </Dialog>
          <Dialog
            open={scanDialog}
            PaperProps={{
              style: {
                margin: "0",
              },
            }}
            onBackdropClick={() => setOpenScan(false)}
          >
            <ScanPopup
              setOpenScan={setOpenScan}
              errorMsg={scanError}
              setScanError={setScanError}
              handleScanDialog={handleScanDialog}
            />
          </Dialog>
          {hasQrScan && (
            <Dialog
              open={qrDialogOpen}
              PaperProps={{
                style: {
                  margin: "0",
                },
              }}
              onBackdropClick={() => setQrDialogOpen(false)}
            >
              <QrPopup
                setOpenScan={setQrDialogOpen}
                errorMsg={scanError}
                setScanError={setScanError}
                handleScanDialog={handleScanDialog}
              />
            </Dialog>
          )}
          <Dialog
            open={zoneDialog}
            fullWidth
            classes={{ paper: classes.dialogPaper }}
            onBackdropClick={() => setOpenZone(false)}
          >
            <MobileVmiZones
              setOpenZone={setOpenZone}
              setOpenRequest={setOpenRequest}
              setSelectedProductData={setSelectedProductData}
              setSelectedZoneId={setSelectedZoneId}
              selectedZoneId={selectedZoneId}
            />
          </Dialog>
          <Dialog
            open={filterDialog}
            fullWidth
            classes={{ paper: classes.dialogPaper }}
            onBackdropClick={() => setOpenFilter(false)}
          >
            <>
              <div className={classes.filterDialog}>
                <div className={classes.scanProductNav}>
                  <div className={classes.closeButtonContainer}>
                    <Close
                      className={classes.closeButton}
                      onClick={() => setOpenFilter(false)}
                    />
                  </div>
                </div>
                <div className={classes.filterContainer}>
                  <MultiSelect
                    handleMultiSelect={handleMultiSelect}
                    sendingRequest={sendingRequest}
                    setSendingRequest={setSendingRequest}
                    setOpenFilter={setOpenFilter}
                  />
                </div>
              </div>
            </>
          </Dialog>
          <VMITopBar
            section={componentTab}
            handleChangeView={handleChangeView}
          />
          <div className={classes.displayView}>
            {componentTab === "requests" && getWidth() > 478 ? (
              <div className={classes.selectionSection}>
                <div
                  className={classes.selectionOption}
                  onClick={() => handleSelectAll()}
                >
                  <Radio color="primary" checked={selectAll} />
                  <div>
                    {I18n.get("all_vmi")} ({allVmi.length})
                  </div>
                </div>
                <div
                  className={classes.selectionOption}
                  onClick={() => handleSelectPop()}
                >
                  <Radio color="primary" checked={selectPop} />
                  <div>
                    {I18n.get("vmi_with")} ({populatedVmi.length})
                  </div>
                </div>
                <div
                  className={classes.selectionOption}
                  onClick={() => handleSelectEmp()}
                >
                  <Radio color="primary" checked={selectEmp} />
                  <div>
                    {I18n.get("vmi_without")} ({emptyVmi.length})
                  </div>
                </div>
              </div>
            ) : null}
            <div
              className={`${componentTab === "requests"
                ? classes.containerReq
                : classes.containerOrd
                }`}
            >
              {componentTab === "requests" ? (
                <div className={classes.vmiTableContainer}>
                  <table className={classes.tableAdmin}>
                    <thead>
                      <tr>
                        <th className={classes.tableCode}>
                          <div className={classes.tableSubtitle}>
                            {I18n.get("companies_company")}
                          </div>
                          <div className={classes.inputContainer}>
                            <TextField
                              value={filters.company || ""}
                              onChange={(e, value) => addFilter(e, "company")}
                              variant="outlined"
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment
                                    position="start"
                                    style={{ color: "rgba(0, 0, 0, 0.38)" }}
                                  >
                                    <Search />
                                  </InputAdornment>
                                ),
                                endAdornment: filters.company ? (
                                  <InputAdornment
                                    position="start"
                                    style={{
                                      color: "rgba(0, 0, 0, 0.38)",
                                      cursor: "pointer",
                                      paddingRight: "0px",
                                    }}
                                    onClick={(e) => removeFilter("company")}
                                  >
                                    <Close />
                                  </InputAdornment>
                                ) : null,
                                style: { paddingRight: "0px" },
                                className: classes.searchCodeInput,
                              }}
                            />
                          </div>
                        </th>
                        <th className={classes.tableCode}>
                          <div className={classes.tableSubtitle}>
                            {I18n.get("companies_site")}
                          </div>
                          <div className={classes.inputContainer}>
                            <TextField
                              value={filters.site || ""}
                              onChange={(e, value) => addFilter(e, "site")}
                              variant="outlined"
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment
                                    position="start"
                                    style={{ color: "rgba(0, 0, 0, 0.38)" }}
                                  >
                                    <Search />
                                  </InputAdornment>
                                ),
                                endAdornment: filters.site ? (
                                  <InputAdornment
                                    position="start"
                                    style={{
                                      color: "rgba(0, 0, 0, 0.38)",
                                      cursor: "pointer",
                                      paddingRight: "0px",
                                    }}
                                    onClick={(e) => removeFilter("site")}
                                  >
                                    <Close />
                                  </InputAdornment>
                                ) : null,
                                style: { paddingRight: "0px" },
                                className: classes.searchCodeInput,
                              }}
                            />
                          </div>
                        </th>
                        <th className={classes.tableCode}>
                          <div className={classes.tableSubtitle}>
                            {I18n.get("sector")}
                          </div>
                          <div className={classes.inputContainer}>
                            <TextField
                              value={filters.sector || ""}
                              onChange={(e, value) => addFilter(e, "sector")}
                              variant="outlined"
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment
                                    position="start"
                                    style={{ color: "rgba(0, 0, 0, 0.38)" }}
                                  >
                                    <Search />
                                  </InputAdornment>
                                ),
                                endAdornment: filters.sector ? (
                                  <InputAdornment
                                    position="start"
                                    style={{
                                      color: "rgba(0, 0, 0, 0.38)",
                                      cursor: "pointer",
                                      paddingRight: "0px",
                                    }}
                                    onClick={(e) => removeFilter("sector")}
                                  >
                                    <Close />
                                  </InputAdornment>
                                ) : null,
                                style: { paddingRight: "0px" },
                                className: classes.searchCodeInput,
                              }}
                            />
                          </div>
                        </th>
                        <th
                          className={`${classes.tableProduct} ${classes.tableCode}`}
                        >
                          <span className={classes.vmiSort}>
                            <span className={classes.tableSubtitle}>VMI</span>
                            <div
                              className={classes.sortContainer}
                              onClick={() => setSortByVmiName(!sortByVmiName)}
                            >
                              {!sortByVmiName ? (
                                <img
                                  src={DropdownDown}
                                  className={classes.dropdownInverted}
                                  alt="Sort Up Arrow"
                                />
                              ) : (
                                <img src={DropdownDown} alt="Sort Down Arrow" />
                              )}
                            </div>
                          </span>
                          <div className={classes.inputContainer}>
                            <TextField
                              value={filters.VMI || ""}
                              onChange={(e, value) => addFilter(e, "VMI")}
                              variant="outlined"
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment
                                    position="start"
                                    style={{ color: "rgba(0, 0, 0, 0.38)" }}
                                  >
                                    <Search
                                      onClick={() => console.log(filters)}
                                    />
                                  </InputAdornment>
                                ),
                                endAdornment: filters.VMI ? (
                                  <InputAdornment
                                    position="start"
                                    style={{
                                      color: "rgba(0, 0, 0, 0.38)",
                                      cursor: "pointer",
                                    }}
                                    onClick={(e) => removeFilter("VMI")}
                                  >
                                    <Close />
                                  </InputAdornment>
                                ) : null,
                                style: { paddingRight: "0px" },
                                className: classes.searchCodeInput,
                              }}
                            />
                          </div>
                        </th>
                        <th
                          className={`${classes.tableQuantity} ${classes.tableCode}`}
                        >
                          <div className={classes.tableSubtitle}>
                            {I18n.get("site_products")}
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>{renderVmiList()}</tbody>
                  </table>
                </div>
              ) : (
                <>
                  <Orders
                    vmiIds={multiSelectZones}
                    addFilter={addFilter}
                    filters={filters}
                    removeFilter={removeFilter}
                  />
                </>
              )}
            </div>
          </div>
        </Grid>
      </Grid>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(VMITable))
);
